<template>
    <div class="group-sender-case">
        <div class="back-step-page">
            <div class="cursor-pointer" @click="$emit('pageStepBack')">
                <i class="fas fa-chevron-left" style="color: #11CDEF;"></i>
                <span class="text-back-step">
                    ย้อนกลับไปยังหน้า POS
                </span>
            </div>
        </div>
        <div class="sender-box">
            <div class="label-create-inter">
                สร้างรายการส่งต่างประเทศ
            </div>
            <div class="label-sender mr-1">
                <span>
                    ที่อยู่ผู้ส่ง
                </span>
                <span class="warning-text">
                    {{ basefillupSetting.mutedText }}
                </span>
            </div>
            <div class="row group-input">
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0"> 
                            <span class="text-danger">*</span><span>Sender name </span><span class="muted">(ชื่อ นามสกุล ผู้ส่ง)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.name" type="text" class="form-control" placeholder="" :class="{ 'is-invalid': errorshow.inputSender.name.language || inputSenderValidation.name.$error }">
                    <label
                    v-if="!inputSenderValidation.name.required"
                    class="invalid-feedback"
                    >
                        กรุณากรอกชื่อ-สกุลผู้ส่ง
                    </label>
                    <label
                    v-else-if="errorshow.inputSender.name.language"
                    class="invalid-feedback"
                    >
                        กรุณากรอก ชื่อ-สกุลผู้ส่ง เป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>Sender Phone number </span><span class="muted">(เบอร์โทรศัพท์ผู้ส่ง)</span>
                        </p>
                    </label>
                    <div class="row">
                        <div class="col-1 col-md-4 col-lg-4">
                            <b-form-group id="input-group-1" label-for="input-1">
                                <v-select 
                                    :options="countries"
                                    label="text"
                                    @input="SetseletedCountry($event)"
                                    v-model="inputSender.selectedPhoneCountry.showInput"
                                    :class="{ 'is-invalid bd-danger': inputSenderValidation.selectedPhoneCountry.alpha_2_code.$error }" 
                                >
                                <template slot="option" slot-scope="option">
                                    +{{ option.calling_code }} {{ option.text }}
                                </template>
                                </v-select>
                                <label
                                v-if="!inputSenderValidation.selectedPhoneCountry.alpha_2_code.required"
                                class="invalid-feedback">
                                    กรุณาเลือกประเทศ เบอร์โทรศัพท์
                                </label>
                            </b-form-group>
                        </div>
                        <div class="col-11 col-md-8 col-lg-8">
                            <input class="form-control" type="text" id="phone" v-model="inputSender.tel" :class="{ 'is-invalid': inputSenderValidation.tel.$error }" @input="formatPhoneNumber">
                            <label
                                v-if="!inputSenderValidation.tel.required"
                                class="invalid-feedback"
                            >กรุณากรอกเบอร์โทร</label>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span>Company </span><span class="muted">(ชื่อบริษัท)</span>
                        </p>
                    </label>
                    <input class="form-control" type="text" 
                        :class="{ 'is-invalid': errorshow.inputSender.company.language }" 
                        v-model="inputSender.company" maxlength="30">
                    <label
                    v-if="errorshow.inputSender.company.language"
                    class="invalid-feedback"
                    >
                        กรุณากรอก ชื่อ-บริษัท เป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span>Taxpayer ID </span><span class="muted">(หมายเลขผู้เสียภาษี)</span>
                        </p>
                    </label>
                    <input class="form-control" type="text" v-model="inputSender.taxId">
                </div>
                <div class="col-12 col-md-12 col-lg-12">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>Sender Address 1 </span><span class="muted">(ที่อยู่ผู้ส่ง)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.address" type="text" :maxlength="maxCharacters" class="form-control" :class="{ 'is-invalid': errorshow.inputSender.address.language || inputSenderValidation.address.$error }" placeholder="">
                    <label
                        v-if="!inputSenderValidation.address.required"
                        class="invalid-feedback"
                    >
                        กรุณากรอกที่อยู่ผู้ส่ง
                    </label>
                    <label
                        v-else-if="errorshow.inputSender.address.language"
                        class="invalid-feedback"
                    >
                        กรุณากรอกที่อยู่ผู้ส่งเป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-12 col-lg-12">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span>Sender Address 2 </span><span class="muted">(ที่อยู่ผู้ส่ง)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.address2" type="text" :maxlength="maxCharacters" class="form-control" :class="{ 'is-invalid': errorshow.inputSender.address2.language }" placeholder="">
                    <label
                        v-if="errorshow.inputSender.address2.language"
                        class="invalid-feedback"
                    >
                        กรุณากรอกที่อยู่ผู้ส่งเป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>Province </span><span class="muted">(จังหวัด)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.province" type="text" class="form-control" :class="{ 'is-invalid': errorshow.inputSender.province.language || inputSenderValidation.province.$error }" placeholder="">
                    <label
                        v-if="!inputSenderValidation.province.required"
                        class="invalid-feedback"
                    >
                        กรุณากรอกจังหวัด
                    </label>
                    <label
                        v-else-if="errorshow.inputSender.province.language"
                        class="invalid-feedback"
                    >
                        กรุณากรอกจังหวัดเป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>District </span><span class="muted">(อำเภอ/เขต)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.district" type="text" class="form-control" :class="{ 'is-invalid': errorshow.inputSender.district.language || inputSenderValidation.district.$error }" placeholder="">
                    <label
                        v-if="!inputSenderValidation.district.required"
                        class="invalid-feedback"
                    >
                        กรุณากรอกอำเภอหรือเขต
                    </label>
                    <label
                        v-else-if="errorshow.inputSender.district.language"
                        class="invalid-feedback"
                    >
                        กรุณากรอกอำเภอหรือเขตเป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>Sub-district </span><span class="muted">(ตำบล/แขวง)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.subdistrict" type="text" class="form-control" :class="{ 'is-invalid': errorshow.inputSender.subdistrict.language || inputSenderValidation.subdistrict.$error }" placeholder="">
                    <label
                        v-if="!inputSenderValidation.subdistrict.required"
                        class="invalid-feedback"
                    >
                        กรุณากรอกตำบลหรือแขวง
                    </label>
                    <label
                        v-else-if="errorshow.inputSender.subdistrict.language"
                        class="invalid-feedback"
                    >
                        กรุณากรอกตำบลหรือแขวงเป็น{{ LanguageMessage }}
                    </label>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label class="label-input" for="">
                        <p class="m-0">    
                            <span class="text-danger">*</span><span>Postal Code </span><span class="muted">(รหัสไปรษณีย์)</span>
                        </p>
                    </label>
                    <input v-model="inputSender.postcode" type="text" class="form-control" :class="{ 'is-invalid': inputSenderValidation.postcode.$error }" placeholder="000000">
                    <label
                        v-if="!inputSenderValidation.postcode.required"
                        class="invalid-feedback"
                    >
                        กรุณากรอกรหัสไปรษณีย์
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { getCountryCallingCode } from 'libphonenumber-js/max';

export default {
    props: {
        inputSenderValidation: {
            required: true
        },
        inputSender: {
            type: [Array, Object]
        },
        countries: [Array, Object],
        basefillupSetting: {
            type: Object
        },
        errorshow: {
            type: Object
        },
        cart: {
            type: [Array, Object]
        }
    },
    data() {
        return {
            filteredCountries: [],
            searchText: 'thailand',
            maxCharacters: 50
        }
    },
    computed: {
        LanguageMessage() {
            return this.basefillupSetting.typeFillup === 'ENGLISH' ? 'ภาษาอังกฤษ' : 'ภาษาไทย'
        },
    },
    methods: {
        formatPhoneNumber() {
            const phoneNumberWithCallingCode = `${this.inputSender.tel}`;
            const parsedNumber = parsePhoneNumberFromString(phoneNumberWithCallingCode);
            if (parsedNumber) {
              this.inputSender.tel = parsedNumber.formatInternational();
            }
        },
        SetseletedCountry(event) {
            this.inputSender.selectedPhoneCountry.showInput = '+' + event.calling_code + ' '+ event.text
            this.inputSender.selectedPhoneCountry.text = event.text
            this.inputSender.selectedPhoneCountry.alpha_2_code = event.alpha_2_code
            this.inputSender.selectedPhoneCountry.alpha_3_code = event.alpha_3_code
            this.inputSender.selectedPhoneCountry.calling_code = event.calling_code
            this.inputSender.selectedPhoneCountry.destination_supported = event.destination_supported
            this.inputSender.selectedPhoneCountry.id = event.id
            this.inputSender.selectedPhoneCountry.manufacturer_supported = event.manufacturer_supported
        }
    },
    mounted() {
    }
}
</script>